<template>
  <div class="eventList">

    <div class="title">
      <i class="fas fa-bars"></i>
      {{$t('global.events')}}
    </div>

    <div class="d-flex flex-column">
      <div class="itemList"
           v-if="items && items.length > 0">
        <div v-for="item in items"
             :key="item.id"
             class="item">
          <div class="event"> {{item.message}}</div>
          <div class="date"> {{$customFunctions.setMomentWithFormat(item.created_at, 'DD.MM.yyyy HH:mm')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventList',
  props: {
    items: {
      type: Array,
      default: [],
    },
  },
}
</script>

<style lang="scss" scoped>
.eventList {
  width: 100%;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    i {
      color: #00baf2;
      margin-right: 5px;
      font-size: 16px;
      line-height: 21px;
    }
  }
  .itemList {
    margin-left: 24px;
    max-height: 275px;
    overflow: auto;

    .item {
      padding: 20px 0px;
      border-bottom: 1px solid #e5eaee;
      &:last-child {
        padding-bottom: 0px;
        border-bottom: 0px;
      }
      .event {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 19px;
        color: #000000;
      }
      .date {
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        color: #b5b5c3;
      }
    }
  }
}
</style>